import { sortBy } from 'lodash'

// Drops null status records and sorts the primary membership first.
const getAllValidMemberships = (memberships) =>
  sortBy(
    memberships.filter(({ membership_status__c }) => membership_status__c),
    [
      ({ primary_membership__c }) => !primary_membership__c,
      'membership_number__c',
    ]
  )

export default getAllValidMemberships
